/**
 * Cross-cutting product constants.
 *
 * Licensing is handled per customer — every "contact us about a license"
 * surface (lockout page, Settings license tab, gated-feature messaging)
 * must point at the same address. Change it here, nowhere else.
 */
export const LICENSING_CONTACT_EMAIL = "fgandolfo@tozenlabs.com";
